export const parseSessionDate = (sessionDate) => {
  if (!sessionDate) return null;

  if (typeof sessionDate === 'string') {
    const datePart = sessionDate.match(/^(\d{4})-(\d{2})-(\d{2})/) || [];
    if (datePart.length === 4) {
      const year = Number(datePart[1]);
      const month = Number(datePart[2]);
      const day = Number(datePart[3]);
      return new Date(year, month - 1, day);
    }
  }

  const parsed = new Date(sessionDate);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
};

export const toDateKey = (inputDate) => {
  const parsed = parseSessionDate(inputDate);
  if (!parsed) return '';

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDate = (sessionDate) => {
  const parsed = parseSessionDate(sessionDate);
  if (!parsed) return '-';
  return parsed.toLocaleDateString();
};
